// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
// Afidium
import { CardModule } from 'libraries/ui_card/card.module';
import { PopupMenuModule } from 'libraries/component/popup-menu/popup-menu.module';
import { PopupMenuPermissionService } from 'app_sasha/shared/services/popup-menu-permission/popup-menu-permission.service';
import { NotificationModule } from 'libraries/component/notification/notification.module';
import { LoaderModule } from 'libraries/component/loader/loader.module';
import { BookingSavedSearchedSummaryComponent } from './booking-saved-searched-summary.component';
import { BookingSummaryBadgeComponent } from '../booking-summary-badge/booking-summary-badge.component';
import { BookingSearchParameters } from 'app_sasha/shared/models/BookingSearchParameters';
import { BookingResourceModule } from 'libraries/service/resources/booking/bookingResource.module';
import { SavedSearchComponent } from './saved-search.component';
import { LocalizedModule } from 'libraries/pipes/localized/localized.module';
import { DatesModule } from 'app_sasha/shared/services/dates/dates.module';
import { ShortNumberSuffixModule } from "libraries/pipes/short-number-suffix/short-number-suffix.module";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";

@NgModule({
    declarations: [
        BookingSavedSearchedSummaryComponent,
        BookingSummaryBadgeComponent,
        SavedSearchComponent,
    ],
    imports: [
        CommonModule,
        CardModule,
        PopupMenuModule,
        NotificationModule,
        LoaderModule,
        RouterModule,
        BookingResourceModule,
        LocalizedModule,
        DatesModule,
        ShortNumberSuffixModule,
        FontAwesomeModule,
    ],
    exports: [
        BookingSavedSearchedSummaryComponent,
    ],
    providers: [
        PopupMenuPermissionService,
        BookingSearchParameters,
    ],
})
export class BookingSavedSearchedSummaryModule { }
